import type { ReactNode } from "react";

export interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
}

/**
 * One h1 per page. Location lives in the shell breadcrumb, so there is no
 * eyebrow here. Actions align to the header, not scattered across the page.
 */
export function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <div className="page-header">
      <div className="page-header-text">
        <h1>{title}</h1>
        {description ? <p>{description}</p> : null}
      </div>
      {actions ? <div className="ui-header-actions">{actions}</div> : null}
    </div>
  );
}

export interface SectionHeaderProps {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
}

/** Header for a section within a page — same actions contract, smaller title. */
export function SectionHeader({ title, description, actions }: SectionHeaderProps) {
  return (
    <div className="ui-section-header">
      <div>
        <h2 className="section-label">{title}</h2>
        {description ? <p className="form-field-helper">{description}</p> : null}
      </div>
      {actions ? <div className="ui-header-actions">{actions}</div> : null}
    </div>
  );
}
